import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    primary: {
      main: "hsl(26, 100%, 55%)",
      green: "hsl(25, 100%, 94%)",
    },
  },
});
